import { ReactNode } from 'react';
import cx from 'classnames';

import { Direction } from './API/Direction';

interface TitleProps {
    className?: string;
    direction?: Direction;
    children?: ReactNode;
}

const Title = ({ className = '', direction = 'horizontal', children }: TitleProps) => {
    return (
        <div className={cx('flex items-center', {
            'mx-auto': ! className.includes('mx-'),
            'mb-8': ! className.includes('mb-'),
            'flex-row gap-8': direction === 'horizontal',
            'flex-col': direction === 'vertical',
            [className]: Boolean(className)
        })}>
            <div className='w-full'>
                {children}
            </div>
        </div>
    );
};

export { Title };